<template>
  <div>
    <v-card>
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">NEW CHART OF ACCOUNTS</h4></v-toolbar-title>
      </v-toolbar>
      <v-form ref="form2" class="multi-col-validation">
        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md4>
            <v-select
              v-model="category_id"
              class="mx-2"
              dense
              outlined
              label="Category"
              :items="category_items"
              item-value="id"
              item-text="category"
              @change="selected_category"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2 mt-5">
          <v-flex xs12 md3>
            <v-select
              outlined
              class="mx-2"
              v-model="title"
              dense
              label="Data"
              :items="['Assets','Liabilities','Income','Expenses','Equity']"
              :rules="rules.combobox_rule"
              @change="selected_title"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3 v-if="title==='Assets'||title==='Liabilities'">
            <v-select
              outlined
              class="mx-2"
              v-model="title_data"
              dense
              label="Title"
              :items="title_data_items"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3>
            <v-checkbox v-model="is_children" label="Is Children" hide-details
                        @change="selected_check"
                        class="me-3 mt-1"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2" v-if="!is_children">
          <v-flex xs12 md3>
            <v-text-field
              class="mx-2"
              v-model="account_no"
              label="Code"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md9>
            <v-text-field
              class="mx-2"
              v-model="name"
              label="Account Title"
              dense
              outlined
              :rules="rules.default_max_255_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              class="mx-2"
              v-model="details"
              label="Details"
              dense
              outlined
              :rules="rules.default_max_255_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2" v-if="is_children">
          <v-flex xs12 md6>
            <v-select
              v-model="title_id"
              class="mx-2"
              dense
              outlined
              label="Parent Account Title"
              :items="title_items"
              item-value="id"
              item-text="particulars"
              @change="selected_particulars"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-flex>
          <v-flex xs12 md6>
          </v-flex>
          <v-flex xs12 md12>
            <v-text-field
              class="mx-2"
              v-model="name"
              label="Children Account Title"
              dense
              outlined
              :rules="rules.default_max_255_character_and_no_empty_rule"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="align-center mx-2">
          <v-col cols="12" v-show="alert">
            <v-alert color="warning" text class="mb-0">
              <div class="d-flex align-start">
                <v-icon color="warning">
                  {{ icons.mdiAlertOutline }}
                </v-icon>

                <div class="ms-3">
                  <p class="text-base font-weight-medium mb-1">
                    {{ alert_message }}
                  </p>
                </div>
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12" md="12">
            <v-btn class="w-full" color="primary" @click="save_request" v-if="!saving_data"> Save
              Request
            </v-btn>
            <v-progress-circular :size="50" :width="5" color="primary" indeterminate
                                 v-else></v-progress-circular>
          </v-col>
        </v-layout>
      </v-form>
      <v-data-table
        dense
        :headers="headers"
        :items="data_items2"
        height="600"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              {{ item.code }}
            </td>
            <td>
              {{ item.master_title }}
            </td>
            <td>
              {{ item.master_data_title }}
            </td>
            <td>
              {{ item.particulars }}
            </td>
            <td>
              {{ item.details }}
            </td>
            <td v-if="item.children.length>0">
              <v-data-table
                dense
                :headers="headers2"
                :items="item.children"
                height="600"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td>
                      {{ item.particulars }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <snack-bar-dialog :snackbar_flag="this.snackbar" :color="this.snackbar_color"
                      :snackbar_text="this.snackbar_text"/>
  </div>
</template>

<script>
import {
  mdiAccountReactivate, mdiHandshake, mdiAccountGroup,
  mdiPencil,
  mdiHistory,
} from '@mdi/js'
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

const initialState = () => {
  return {
    saving_data: false,
    alert: false,
    alert_message: '',
    is_deleting: false,
    can_edit: false,
    is_children: false,

    title_id: '',
    title: '',
    title_data: '',
    details: '',
    title_data_items: [],
    title_items: [],

    is_forbidden: true,
    name: '',
    account_no: '',
    particulars_id: '',
    branch_id: '',
    selection: '',
    category_id: '',
    selection_data: 'Generals',
    amount: '',
    due_date: '',
    particulars_items: [],
    branch_items: [],
    category_items: [],

    data_items2: [],

    selected_affiliate_id: -1,

    headers: [
      {text: 'Code', value: 'date_of_deposit', sortable: false},
      {text: 'Title', value: 'name', sortable: true},
      {text: 'Data', value: 'account_no', sortable: true},
      {text: 'Account Title', value: 'date_of_deposit', sortable: false},
      {text: 'Details', value: 'date_of_deposit', sortable: false},
      {text: 'Children', value: 'date_of_deposit', sortable: false},
    ],
    headers2: [
      {text: 'Children Account Title', value: 'date_of_deposit', sortable: false},
    ],
  }
}
export default {
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAccountReactivate,
        mdiAccountGroup,
        mdiHandshake,
        mdiPencil,
        mdiHistory,
      },
    }
  },
  data() {
    return initialState()
  },
  mounted() {
    this.initialize_data()
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', ['employee_id']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('request_particulars', ['initialize_new_particulars', 'list_of_particulars_by_master_title', 'register_particulars', 'list_of_chart_of_accounts']),
    ...mapActions('branch_information', ['branch_data']),
    initialize_data() {
      this.initialize_new_particulars()
        .then(response => {
          this.category_items = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    selected_category() {
      this.list_of_chart_of_accounts({category_id: this.category_id})
        .then(response => {
          this.data_items2 = response.data
        })
        .catch(error => {
          console.log(error)
        })
      this.selected_check()
    },
    selected_check() {
      this.title_items = []
      if (this.is_children) {
        this.list_of_particulars_by_master_title({
          category_id: this.category_id,
          master_title: this.title,
          master_data_title: this.title_data,
        })
          .then(response => {
            this.title_items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    selected_particulars() {
    },
    selected_title() {
      this.title_data_items = []
      this.title_data = ''
      if (this.title === 'Assets') {
        this.title_data_items = ['Current Assets', 'Non-Current Assets']
      } else if (this.title === 'Liabilities') {
        this.title_data_items = ['Current Liabilities', 'Non-Current Liabilities']
      }
    },
    save_request() {
      this.saving_data = true
      this.alert = false
      var cat = this.category_id
      if (this.$refs.form2.validate()) {
        const data = new FormData()
        data.append('category_id', this.category_id)
        data.append('particulars', this.name)
        data.append('master_title', this.title)
        data.append('master_data_title', this.title_data)
        data.append('details', this.details)
        data.append('code', this.account_no)
        data.append('is_children', this.is_children ? 1 : 0)
        data.append('particulars_id', this.title_id)
        this.register_particulars(data)
          .then(response => {
            var color = 'error'
            if (response.status === 200) {
              color = 'success'
            }
            this.change_snackbar({
              show: true,
              color: color,
              text: response.data,
            })
            this.saving_data = false
            Object.assign(this.$data, initialState())
            this.initialize_data()
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving_data = false
      }
    },
  },
}
</script>
